/**
 * 触屏优先设备（手机 / 平板）检测。
 *
 * 用途：选择预览类交互的默认路径。移动端浏览器（iOS Safari / Android Chrome）
 * 的原生 <iframe> 无法内嵌渲染 PDF（只显示空白或触发下载），因此触屏设备上
 * PDF 一律默认走 PDF.js canvas 渲染；桌面（鼠标为主）才使用 iframe 快速预览。
 */
export function isTouchPrimary(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    // 主输入为手指（手机 / 平板）
    const coarse = !!window.matchMedia?.('(pointer: coarse)')?.matches;
    // iPadOS 13+ 默认伪装成桌面 Safari，靠多点触控识别
    const iPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    // UA 兜底（部分 Android WebView 不上报 coarse pointer）
    const uaMobile = /Android|iPhone|iPad|iPod|Mobile|Silk/i.test(navigator.userAgent);
    return coarse || iPadOS || uaMobile;
  } catch {
    return false;
  }
}
